import { featureCreditMockMode, featureCreditMockScenario } from '@/config/featureFlags';
import { normalizeUnlockQueryResponse } from '@/core/api/adapters/unlockAdapter';
import unlockMockService from '@/core/api/mocks/unlockMockService';

const createProviderNotReadyError = () => {
  const error = new Error('unlock_sync_provider_not_ready');
  error.code = 'unlock_sync_provider_not_ready';
  return error;
};

const resolveService = () => {
  if (featureCreditMockMode) {
    return unlockMockService;
  }

  return null;
};

const withScenario = (params = {}) => ({
  ...params,
  scenarioId: params?.scenarioId || featureCreditMockScenario
});

const unlockGateway = {
  async queryScopeUnlockState(params = {}) {
    const service = resolveService();
    if (!service?.queryScopeUnlockState && !service?.queryImageUnlockState) {
      throw createProviderNotReadyError();
    }

    const queryFn = service.queryScopeUnlockState || service.queryImageUnlockState;
    const response = await queryFn(withScenario(params));
    return normalizeUnlockQueryResponse(response, {
      fallbackScope: {
        scopeKey: params?.scopeKey,
        scopeType: params?.scopeType,
        originalHashId: params?.originalHashId || params?.imageId,
        presetStyleId: params?.presetStyleId
      },
      fallbackImageId: params?.imageId
    });
  },

  async queryImageUnlockState(params = {}) {
    return this.queryScopeUnlockState(params);
  }
};

export default unlockGateway;
